import type { TenantVersions } from "@/api/tenantRuntime";

/** `<environment> · brain <8 chars or "?"> · <packName>@<packRevision>`. */
export function formatVersionsChip(versions: TenantVersions): string {
  const brain = versions.brainCommit?.slice(0, 8) ?? "?";
  const pack =
    versions.packRevision === null
      ? versions.packName
      : `${versions.packName}@${versions.packRevision}`;
  return `${versions.environment} · brain ${brain} · ${pack}`;
}
